export default __webpack_public_path__ + "static/media/20-black.f17adcc6.png";